<template>
  <vx-card
    :title="`Приборы учета и ${showConsumption ? 'расход' : 'показания'}`"
    class="vx-card_full-height employee-devices-panel"
  >
    <div slot="actions" class="employee-devices-panel__consumption">
      <label class="employee-devices-panel__consumption-label">Расход</label>
      <app-switch
        v-model="showConsumption" ref="toggleShowInactiveDevices" size="small"
        class="employee-devices-panel__consumption-switch"
      />
    </div>
    <div class="employee-devices-panel__header">
      <div class="employee-devices-panel__filters">
        <div class="employee-devices-panel__filters-filter con-select">
          <elsa-v-select
            :options="apartmentFilterOptions"
            v-model="selectedApartmentsType"
            label="name"
            :reduce="item => item.id"
            :clearable="false"
            :disabled="apartmentsTypes.length <= 1"
            htmlLabel="Тип помещения"
            :styleType="['small', 'square']"
          />
        </div>
        <div class="employee-devices-panel__filters-filter">
          <app-datepicker
            label="Период с" v-model="date_from"
            format="MMMM yyyy"
            minimumView="month"
            :disabledDates="disabledDatesFrom"
          />
        </div>
        <div class="employee-devices-panel__filters-filter">
          <app-datepicker
            label="Период по" v-model="date_to"
            format="MMMM yyyy"
            minimumView="month"
            :disabledDates="disabledDatesTo"
          />
        </div>
      </div>
      <div class="employee-devices-panel__actions">
        <div class="employee-devices-panel__actions-button">
          <vs-button
            type="border"
            @click="openAddAct"
            iconPack="feather" icon="icon-plus" title="Добавить"
            v-if="$can('rp.devices', 'write')"
          />
        </div>
        <div class="employee-devices-panel__actions-button">
          <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer" v-if="$can('rp.devices', 'write')">
            <vs-button
              type="border"
              class="employee-devices-panel__actions-button"
              iconPack="feather"
              icon="icon-upload" title="Импортировать"
            />
            <vs-dropdown-menu ref="profileDropdownMenu">
              <ul style="min-width: 9rem">
                <li @click="openDeviceImport" class="employee-devices-panel__dropdown-item">
                  <div class="employee-devices-panel__dropdown-item-icon">
                    <app-icon name="MeterIcon1" size="20px" />
                  </div>
                  <div class="employee-devices-panel__dropdown-item-name">
                    Приборы
                  </div>
                </li>
                <li @click="openValuesImport" class="employee-devices-panel__dropdown-item">
                  <div class="employee-devices-panel__dropdown-item-icon">
                    <app-icon name="ListIcon" size="20px" />
                  </div>
                  <div class="employee-devices-panel__dropdown-item-name">
                    Показания
                  </div>
                </li>
              </ul>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
        <div class="employee-devices-panel__actions-button">
          <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer" v-if="$can('rp.devices', 'write')">
            <vs-button
              type="border"
              class="employee-devices-panel__actions-button"
              iconPack="feather"
              icon="icon-download" title="Экспортировать"
            />
            <vs-dropdown-menu ref="profileDropdownMenu">
              <ul style="min-width: 9rem">
                <li @click="exportTable" class="employee-devices-panel__dropdown-item">
                  <div class="employee-devices-panel__dropdown-item-icon">
                    <app-icon name="ListIcon" size="20px" />
                  </div>
                  <div class="employee-devices-panel__dropdown-item-name">
                    Все
                  </div>
                </li>
                <li @click="openExportEncryptedValuesPopup" class="employee-devices-panel__dropdown-item">
                  <div class="employee-devices-panel__dropdown-item-icon">
                    <app-icon name="HashIcon" size="20px" />
                  </div>
                  <div class="employee-devices-panel__dropdown-item-name">
                    Шифрованные показания
                  </div>
                </li>
              </ul>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
        <div class="employee-devices-panel__actions-button">
          <vs-button
            type="border" iconPack="feather" icon="icon-settings" title="Дополнительно"
            @click="openAdditionalSettingsPopup" class="employee-devices-panel__actions-button"
          />
        </div>
      </div>
    </div>

    <div class="flex flex-col flex-1" style="min-height: 560px">
      <grid-infinite-scroll
        ref="table"
        :columns="tableColumns"
        :getData="updateValues"
        :maxConcurrentDatasourceRequests="4"
        :rowHeight="50"
        :pageSize="20"
        key="valueTable"
        :filterable="false"
        :sortable="false"
        noRowsText="Показания не найдены"
        @updateVisibleColumns="updateIndicationFilter"
        :editable="$can('rp.devices', 'write')"
        :shownColumns="indicationColumnsFilter"
        :frameworkComponents="valuesComponents"
        :enterMovesDownAfterEdit="true"
        :singleClickEdit="true"
        :getPinnedRows="getValuesPinnedRows"
        :pinnedRowsGetters="valuesPinnedRowsGetters"
        :showPinnedRows="showTotal"
        :rowClassRules="rowClassRules"
        :stopEditingWhenGridLosesFocus="false"
        :tableOptions="tableOptions"
        :defaultSorting="['account_number', 'asc']"
      >
        <div slot="after-table" class="employee-values-toggle-total-row">
          <div
            class="employee-values-toggle-total-row__wrapper link-icon" @click="showTotal = !showTotal"
            :class="{'employee-values-toggle-total-row__wrapper_active': showTotal}"
          >
            <div class="employee-values-toggle-total-row__name">Итого</div>
            <div class="employee-values-toggle-total-row__icon">
              <app-icon name="ChevronDown" size="14px" />
            </div>
          </div>
        </div>
      </grid-infinite-scroll>
    </div>

    <act-popup-new ref="actPopupNew" @created="resetData" />
    <device-import-popup ref="deviceImportPopup" />
    <values-import-popup ref="valuesImportPopup" />
    <export-encrypted-values-popup ref="exportEncryptedValuesPopup" />
    <device-edit-popup ref="deviceEditPopup" @updated="resetData" />
    <additional-settings-popup
      ref="additionalSettingsPopup" :columns="tableColumns" :showInactive.sync="showInactive"
      :indicationColumnsFilter.sync="indicationColumnsFilter"
    />
  </vx-card>
</template>

<script>
import AccountNumberRenderer                   from "@/components/employee/accounts/AccountNumberRenderer";
import DeviceValueEditor                       from "@/components/calculated-program/metering/DeviceValueEditor";
import DeviceTypeRenderer                      from "@/components/calculated-program/metering/DeviceTypeRenderer";
import ActPopupNew                             from "@/components/calculated-program/acts/ActPopupNew";
import DeviceImportPopup                       from "@/components/calculated-program/metering/DeviceImportPopup";
import ValuesImportPopup                       from "@/components/calculated-program/metering/ValuesImportPopup";
import ExportEncryptedValuesPopup
                                               from "@/components/calculated-program/metering/ExportEncryptedValuesPopup";
import AdditionalSettingsPopup                 from "@/components/calculated-program/metering/AdditionalSettingsPopup";
import DeviceEditPopup                         from "@/components/calculated-program/metering/DeviceEditPopup";
import StatusRenderer                          from "@/components/calculated-program/metering/StatusRenderer";
import { renderDeviceCell, renderDeviceValue } from "@/globalFunctions/renderDeviceValue";
import deviceStatuses                          from "@/dictionaries/deviceStatuses";
import notifyHttpError                         from "@/mixins/notifyHttpError";
import parseDate                               from "@/client/helpers/parseDate";
import addMonths                               from 'date-fns/addMonths';
import startOfMonth                            from "date-fns/startOfMonth";
import {
  renderDeviceOperationStartDate,
  renderDeviceOperationStartDateCell,
}                                              from "@/globalFunctions/renderDeviceOperationStartDate";

const SHOW_INACTIVE_DEVICES_IN_LOCAL_STORAGE = 'showInactiveDevices';

export default {
  name:       "Devices",
  mixins:     [notifyHttpError],
  components: {
    ActPopupNew,
    DeviceImportPopup,
    ValuesImportPopup,
    ExportEncryptedValuesPopup,
    AdditionalSettingsPopup,
    DeviceEditPopup,
  },
  data() {
    return {
      showConsumption:         false,
      deviceTypes:             [],
      showTotal:               null,
      valuesComponents:        {
        deviceValueEditor: DeviceValueEditor,
      },
      date_from:               (new Date()).setMonth((new Date()).getMonth() - 6),
      date_to:                 Date.now(),
      indicationColumnsFilter: {
        apartment:            true,
        type:                 true,
        actual_state:         true,
        operation_start_date: true,
        next_checking_date:   true,
        comment:              true,
        start_value:          true,
      },
      selectedApartmentsType:  null,
      showInactive:            false,
      tableOptions:            {},
      statusesDict:            null,
    };
  },
  computed: {
    windowWidth() {
      return this.$store.getters['windowWidth'];
    },
    apartmentsTypes() {
      return this.$store.getters['appUser/availableApartmentsTypes'];
    },
    disabledDatesFrom() {
      return {
        from: new Date(this.date_to),
      };
    },
    disabledDatesTo() {
      return {
        to: new Date(this.date_from),
      };
    },
    selectedHouseId() {
      return this.$store.getters['appUser/selectedHouse'].id;
    },
    valuesPinnedRowsGetters() {
      let columns = {
        account_number: "Всего",
        type:           ( data ) => {
          return data.type !== null ? this.getDeviceTypesById(data.type) : 'Не известный';
        },
      };

      let dateStart = this.$moment(this.date_from);
      let dateEnd = this.$moment(this.date_to);

      while (dateEnd > dateStart || dateStart.format('M') === dateEnd.format('M')) {
        let month = JSON.parse(JSON.stringify(dateStart));
        let date = new Date(month);
        let formattedDate = this.$options.filters.formatDate(date);
        let getValue = ( data ) => {
          let value = data.values.find(value => {
            return value.month === formattedDate;
          });
          let text = '-';

          if (value) {
            if (this.showConsumption) {
              text = value.consumption !== null ? value.consumption : '-';
            } else {
              if (![2, 21, 22].includes(data.type) && value.value !== null) {
                value.value = this.$roundTo(Number(value.value), 2);
              }

              text = value.value !== null ? value.value : '-';
            }
          }
          return text;
        };
        columns[`${this.$options.filters.moment(date, 'YYYY-MM')}`] = ( data ) => {
          return getValue(data);
        };
        dateStart.add(1, 'month');
      }
      return columns;
    },
    tableColumns() {
      if (!this.date_from || !this.date_to) return [];
      let dateStart = this.$moment(this.date_from);
      let dateEnd = this.$moment(this.date_to);

      let columns = [
        {
          headerName:            'Счет',
          field:                 'account_number',
          minWidth:              120,
          editable:              false,
          suppressSizeToFit:     false,
          sortable:              true,
          filter:                true,
          pinned:                this.windowWidth < 500 ? "none" : "left",
          cellRendererFramework: AccountNumberRenderer,
          cellRendererParams:    ( { data } ) => data,
        },
        {
          headerName:        'Помещение',
          field:             'apartment',
          filter:            true,
          editable:          false,
          suppressSizeToFit: false,
          minWidth:          120,
          pinned:            this.windowWidth < 500 ? "none" : "left",
          valueGetter:       ( cell ) => {
            if (cell.node.rowPinned) {
              return '';
            }
            return cell.data.general !== true && cell.data.apartment ? cell.data.apartment.number : 'Общедомовой';
          },
        },
        {
          headerName:            'Тип',
          field:                 'type',
          filter:                'select',
          minWidth:              120,
          pinned:                this.windowWidth < 500 ? "none" : "left",
          filterParams:          {
            multiple: true,
            options:  this.deviceTypes.map(dt => ({
              value: dt.id,
              label: dt.name,
            })).sort(( a, b ) => a.value - b.value),
          },
          suppressSizeToFit:     false,
          editable:              false,
          cellRendererFramework: DeviceTypeRenderer,
          cellRendererParams:    ( { data } ) => Object.assign({
            openEdit: () => {
              this.openEditPopup(data.id);
            },
          }, data),
          valueGetter:           ( { data } ) => {
            let type = data.type !== null ? this.getDeviceTypesById(data.type) : 'Не известный';
            let factoryNumber = data.factory_number !== null ? data.factory_number : 'Без номера';
            return `${type}(${factoryNumber})`;
          },
        },
        {
          headerName:            'Статус',
          field:                 'actual_state',
          filter:                false,
          editable:              false,
          minWidth:              120,
          suppressSizeToFit:     false,
          cellRendererFramework: StatusRenderer,
          cellRendererParams:    ( { data } ) => data,
          valueGetter:           ( { data } ) => {
            return this.statusesDict[data.actual_state].name;
          },
        },
        {
          headerName:   'Ввод в экспл.',
          field:        'operation_start_date',
          minWidth:     120,
          maxWidth:     120,
          editable:     false,
          filter:       false,
          valueGetter:  ( { data } ) => renderDeviceOperationStartDate(data.operation_start_date),
          cellRenderer: ( { data } ) => renderDeviceOperationStartDateCell(data.operation_start_date),
        },
        {
          headerName:   'След. поверка',
          field:        'next_checking_date',
          editable:     false,
          minWidth:     120,
          maxWidth:     120,
          filter:       false,
          cellRenderer: ( cell ) => {
            let style = "";
            let value = "";
            let title = "";

            let deviceDate = this.$moment(cell.value);
            let nowDate = this.$moment(Date.now());
            let data = "";

            if (cell.value !== null) {
              if (nowDate.isAfter(deviceDate)) {
                title = "У прибора вышел срок поверки";
              } else if (deviceDate.diff(nowDate, 'months') < 3) {
                style = "color: rgb(246, 193, 81)";
                title = "До срока поверки осталось меньше 3 месяцев";
                data = "data-high-contrast-color=\"warning\"";
              }
              value = this.$options.filters.moment(cell.value);
            } else {
              value = "-";
            }
            return `<span style="${style}" title="${title}" ${data}>${value}</span>`;
          },
          valueGetter:  ( { data } ) => {
            return data.next_checking_date;
          },
        },
        // {
        //   headerName:   'Собственник',
        //   field:        'apartment.b_owner',
        //   minWidth:     250,
        //   flex:         2,
        //   editable:     false,
        //   filter:       false,
        //   cellRenderer: ( { value } ) => {
        //     const text = value || '-';
        //     return `<span title="${text}">${text}</span>`;
        //   },
        // },
        // {
        //   headerName:  'Телефон',
        //   minWidth:    100,
        //   flex:        2,
        //   editable:    false,
        //   filter:      false,
        //   valueGetter: ( { data } ) => {
        //     const { apartment } = data;
        //     if (!apartment) return '-';
        //     const { owners_u_a } = apartment;
        //     if (!owners_u_a) return '-';
        //     return owners_u_a.reduce(( phones, owner ) => {
        //       const { user: { telephone } } = owner;
        //       if (telephone) phones.push(telephone.toString());
        //       return phones;
        //     }, []).join(', ') || '-';
        //   },
        // },
        {
          headerName:   'Комментарий',
          field:        'comment',
          minWidth:     150,
          flex:         2,
          editable:     false,
          filter:       false,
          valueGetter:  ( { data } ) => {
            return data.comment !== null ? data.comment : '-';
          },
          cellRenderer: ( { value } ) => {
            return value !== null ? `<span title="${value}">${value}</span>` : '';
          },
        },
        {
          headerName:        'Начальное',
          field:             'start_value',
          minWidth:          90,
          editable:          false,
          suppressSizeToFit: false,
          filter:            false,
          valueGetter:       ( { data } ) => {
            return data.start_value !== null ? Number(data.start_value) : '-';
          },
        },
      ];
      while (dateEnd > dateStart || dateStart.format('M') === dateEnd.format('M')) {
        let month = JSON.parse(JSON.stringify(dateStart));
        let date = startOfMonth(new Date(month));
        let formattedDate = this.$options.filters.formatDate(date);
        let prevFormattedDate = this.$options.filters.formatDate(this.$moment(date).clone().subtract(1, 'month'));


        columns.push({
          headerName:       this.$capitalize(this.$options.filters.moment(date, 'MMMM YYYY')),
          field:            `${this.$options.filters.moment(date, 'YYYY-MM')}`,
          editable:         ( cell ) => {
            if (cell.node.rowPinned) return false;
            if (this.showConsumption) return false;
            if (this.$can('support', 'write')) return true;

            const operationStartDate = addMonths(parseDate(cell.data.operation_start_date), 6);
            if (operationStartDate > date) return true;

            let canEdit = true;

            if (cell.data.next_checking_date) {
              let deviceDate = this.$moment(cell.data.next_checking_date);
              let nowDate = this.$moment(date);
              if (nowDate.isAfter(deviceDate)) {
                canEdit = false;
              }
            }
            return canEdit;
          },
          minWidth:         120,
          sortable:         false,
          cellEditor:       'deviceValueEditor',
          cellEditorParams: ( cell ) => {
            let value = cell.data.values.find(value => {
              return value.month === formattedDate;
            });

            let prevValueIndex = cell.data.values.findIndex(value => {
              return value.month === prevFormattedDate;
            });

            let prevValue = prevValueIndex > -1 && cell.data.values[prevValueIndex].value ? cell.data.values[prevValueIndex].value : 0;

            return {
              deviceType:  cell.data.type,
              value:       value ? value.value : '',
              calculated:  value.calculated,
              is_standard: value.is_standard,
              units:       this.units,
              prevValue:   prevValue,
            };
          },
          cellRenderer:     ( cell ) => {
            const value = cell.data.values.find(value => value.month === formattedDate);
            return renderDeviceCell(cell.data, value, this.showConsumption);
          },
          valueGetter:      ( cell ) => {
            let value = cell.data.values.find(value => value.month === formattedDate);
            return renderDeviceValue(cell.data, value, this.showConsumption);
          },
          valueSetter:      async ( { newValue, data } ) => {
            if (newValue === null) return false;

            this.$nextTick(() => {
              const focusedCell = this.tableOptions.api.getFocusedCell();
              this.tableOptions.api.startEditingCell({
                rowIndex: focusedCell.rowIndex,
                colKey:   focusedCell.column.getColId(),
              });
            });

            let oldValue = data.values.find(value => {
              let date = new Date(month);
              return value.month === this.$options.filters.formatDate(date);
            });

            let oldValueBackup = JSON.parse(JSON.stringify(oldValue));


            let revertValue = () => {
              oldValue.id = oldValueBackup.id;
              oldValue.value = oldValueBackup.value;
              oldValue.calculated = oldValueBackup.calculated;
              oldValue.is_standard = oldValueBackup.is_standard;
            };

            if (oldValue.id) {
              if (newValue.value === null) {
                oldValue.id = null;
                oldValue.value = null;
                oldValue.calculated = false;
                oldValue.is_standard = false;
                let deleted = await this.deleteDeviceValue(oldValueBackup.id);
                if (!deleted) {
                  revertValue();
                }
              } else if (newValue.save) {
                oldValue.value = newValue.value;
                oldValue.calculated = false;
                oldValue.is_standard = false;
                let updated = await this.updateDeviceValue({
                  id:          oldValue.id,
                  value:       newValue.value,
                  calculated:  false,
                  is_standard: false,
                });
                if (!updated) {
                  revertValue();
                } else {
                  oldValue.id = updated.id;
                }
              }
            } else {
              if (newValue.value !== null) {
                oldValue.value = newValue.value;
                oldValue.calculated = false;
                oldValue.is_standard = false;

                let created = await this.createDeviceValue({
                  account_number: data.account_number,
                  date_value:     formattedDate,
                  device_id:      data.id,
                  factory_number: data.factory_number,
                  value:          newValue.value,
                  device_type:    data.type,
                });

                if (created === false) {
                  revertValue();
                } else {
                  oldValue.id = created.id;
                }
              }
            }
            this.$refs.table.refreshCells();
          },
        });
        dateStart.add(1, 'month');
      }

      return columns;
    },
    rowClassRules() {
      return {
        'ag-row-danger': ( params ) => {
          if (params.data && [3, 5].includes(Number(params.data.actual_state))) {
            return true;
          }
        },
      };
    },
    apartmentFilterOptions() {
      return [{ id: null, name: 'Все' }].concat(this.apartmentsTypes);
    },
  },
  methods:  {
    openEditPopup( id ) {
      this.$refs.deviceEditPopup.open(id);
    },
    updateDeviceValue( value ) {
      return new Promise(async resolve => {
        let body = Object.assign(value, { buildings_id: this.selectedHouseId });
        try {
          let { data } = await this.$http.put('devices_value/' + body.id, body);
          if (data === 'denied') {
            this.$vs.notify({
              color: 'danger',
              title: 'Ошибка изменения',
              text:  'На данный месяц уже показаны квитанции',
            });
            resolve(false);
          } else if (data === 'is null') {
            this.$vs.notify({
              color: 'danger',
              title: 'Ошибка изменения',
              text:  'Передано некорректное значение',
            });
            resolve(false);
          } else {
            resolve(data.device);
          }
        } catch (e) {
          this.notifyHttpError(e);
          // this.$vs.notify({ color: 'danger', title: 'Ошибка сервера', text: 'Показания не изменены' });
          resolve(false);
        }
      });
    },
    createDeviceValue( value ) {
      return new Promise(async resolve => {
        let body = Object.assign(value, { buildings_id: this.selectedHouseId });
        try {
          let { data } = await this.$http.post('devices_value', body);

          if (data === 'denied') {
            this.$vs.notify({
              color: 'danger',
              title: 'Ошибка изменения',
              text:  'На данный месяц уже показаны квитанции',
            });
            resolve(false);
          } else {
            resolve(data.mc);
          }

        } catch (e) {
          this.notifyHttpError(e);
          // this.$vs.notify({ color: 'danger', title: 'Ошибка сервера', text: 'Показания не изменены' });
          resolve(false);
        }
      });
    },
    deleteDeviceValue( id ) {
      return new Promise(async resolve => {
        try {
          let { data } = await this.$http.delete('devices_value/' + id, {
            params: {
              buildings_id: this.selectedHouseId,
            },
          });
          if (data === 'denied') {
            this.$vs.notify({
              color: 'danger',
              title: 'Ошибка добавления',
              text:  'На данный месяц уже показаны квитанции',
            });
            resolve(false);
          } else {
            resolve(true);
          }
        } catch (e) {
          this.$vs.notify({ color: 'danger', title: 'Ошибка сервера', text: 'Показания не удалены' });
          resolve(false);
        }
      });
    },
    openAdditionalSettingsPopup() {
      this.$refs.additionalSettingsPopup.open();
    },
    openExportEncryptedValuesPopup() {
      this.$refs.exportEncryptedValuesPopup.open();
    },
    exportTable() {
      this.$refs.table.exportRows('Показания');
    },
    openDeviceImport() {
      this.$refs.deviceImportPopup.open();
    },
    openValuesImport() {
      this.$refs.valuesImportPopup.open();
    },
    openAddAct() {
      this.$refs.actPopupNew.openWithType(2);
    },
    getValuesPinnedRows( filters, orderBy ) {
      // let dateFrom = new Date(JSON.parse(JSON.stringify(this.date_from)));
      // dateFrom.setMonth(dateFrom.getMonth() - 1);

      let from = this.$options.filters.formatDate(this.date_from);
      let to = this.$options.filters.formatDate(this.date_to);

      return new Promise(async ( resolve ) => {
        let { data } = await this.$http.get('device_values_house_info', {
          params: {
            orderby:         orderBy,
            filters:         filters,
            buildings_id:    this.selectedHouseId,
            from:            from,
            to:              to,
            with_inactive:   this.showInactive,
            apartments_type: this.selectedApartmentsType === null ? undefined : this.selectedApartmentsType,
          },
        });

        data = Object.values(data).filter(d => d.values.some(v => v.value !== null));

        let pinnedRows = data.map(deviceType => {
          let values = {};

          deviceType.values.forEach(value => {
            values[value.month] = value;
          });

          Object.assign(deviceType, values);

          return deviceType;
        });
        resolve(pinnedRows);
      });
    },
    updateValues( page, filters, orderBy ) {
      let from = this.$options.filters.formatDate(this.date_from);
      let to = this.$options.filters.formatDate(this.date_to);

      let params = {
        orderby:         orderBy,
        filters:         filters,
        page:            page,
        buildings_id:    this.selectedHouseId,
        with_inactive:   this.showInactive,
        from:            from,
        to:              to,
        apartments_type: this.selectedApartmentsType === null ? undefined : this.selectedApartmentsType,
      };

      return this.$http.get('device_with_values', { params }).then(( { data } ) => ({
        response: data,
        data:     data.data,
        total:    data.total,
      }));
    },
    updateIndicationFilter( filter ) {
      this.indicationColumnsFilter = filter;
      localStorage.setItem("IndicationTableColumns", JSON.stringify(filter));
    },
    getDeviceTypesById( id ) {
      let deviceType = this.deviceTypes.find(deviceType => Number(deviceType.id) === Number(id));
      return deviceType ? deviceType.name : 'Неизвестное устройство';
    },
    getDeviceTypes() {
      return new Promise(async resolve => {
        let { data } = await this.$http.get('devices_type');
        this.deviceTypes = data;
        resolve(data);
      });
    },
    updateSelectedApartmentsType() {
      if (this.apartmentsTypes.length === 1) {
        this.selectedApartmentsType = this.apartmentsTypes[0].id;
      } else {
        this.selectedApartmentsType = null;
      }
    },
    resetData() {
      if (this.$refs.table) this.$refs.table.resetData();
    },
    loadStatuses() {
      deviceStatuses.getDict().then(dict => this.statusesDict = dict);
    },
  },
  created() {
    this.showInactive = localStorage.getItem(SHOW_INACTIVE_DEVICES_IN_LOCAL_STORAGE) === 'true';
    this.showTotal = localStorage['employee.devices_values.showTotal'] === 'true';
    this.getDeviceTypes();
    this.updateSelectedApartmentsType();

    if (localStorage.getItem("IndicationTableColumns")) {
      let lcColumns = JSON.parse(localStorage.getItem("IndicationTableColumns"));
      for (let key in this.indicationColumnsFilter) {
        this.indicationColumnsFilter[key] = [true, false].includes(lcColumns[key]) ? lcColumns[key] : true;
      }
    }
  },
  mounted() {
    this.loadStatuses();
  },
  // beforeMount() {
  //   this.tableOptions = {};
  // },
  watch: {
    showTotal() {
      localStorage['employee.devices_values.showTotal'] = this.showTotal;
    },
    apartmentsTypes() {
      this.updateSelectedApartmentsType();
    },
    showConsumption() {
      this.$nextTick(() => {
        this.$refs.table.refreshRows();
      });
    },
    selectedHouseId() {
      this.resetData();
    },
    selectedApartmentsType() {
      this.resetData();
    },
    date_from() {
      this.resetData();
    },
    date_to() {
      this.resetData();
    },
    showInactive( value ) {
      localStorage.setItem(SHOW_INACTIVE_DEVICES_IN_LOCAL_STORAGE, String(!!value));
      this.resetData();
    },
  },
};
</script>

<style lang="scss">
.employee-values-toggle-total-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: right;
  padding-right: 5px;
  border-top: 1px solid #f2f2f2;
  border-bottom: 1px solid #f2f2f2;

  &__wrapper {
    display: inline-flex;
    margin-left: auto;
    padding: 5px 0;

    &_active {
      .employee-values-toggle-total-row__icon {
        transform: rotateX(-180deg);
      }
    }
  }

  &__name {
    font-weight: 600;
    margin-right: 15px;
  }

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    transition: .3s;
  }
}

.employee-devices-panel {
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  &__actions {
    display: flex;
    align-items: center;
    padding-bottom: 5px;
    margin: -5px -5px 0;

    &-button {
      padding: 5px;
    }

    @media screen and (max-width: 500px) {
      width: 100%;
      justify-content: center;
    }

  }

  &__consumption {
    display: flex;
    align-items: center;

    &-label {
      margin-right: 10px;
      font-size: 12px;
      line-height: 1.1;
      font-weight: 500;
      text-transform: uppercase;
    }
  }

  &__filters {
    display: flex;
    align-items: center;
    padding-bottom: 5px;
    margin: -5px -5px 0;

    &-filter {
      padding: 5px;

      .app-select__label,
      .app-datepicker__label {
        font-size: 12px;
      }

      .app-datepicker .vdp-datepicker input,
      .app-select__select.con-select .vs-select--input {
        font-size: 12px;
      }
    }

    @media screen and (max-width: 500px) {
      display: block;
      width: 100%;
    }
  }


  &__dropdown-item {
    display: flex;
    align-items: center;
    padding: 10px;
    margin-right: -5px;
    margin-left: -5px;

    &:hover {
      cursor: pointer;
      background: rgba(var(--app-primary), 1);
      color: #fff;
    }


    &-icon {
      display: flex;
      margin-right: 10px;
    }

    &-name {
      line-height: 1.1;
      white-space: nowrap;
    }


  }

}
</style>
